module.exports = __webpack_public_path__ + "img/ring_y_e_null_1@2x.48b3e707.png";